export default __webpack_public_path__ + "static/Qantas logo-df34a8a377903006a05270e6e2629fc7.png";